export default __webpack_public_path__ + "static/media/trainer_small4.d132fe20.png";